import axios from 'axios'
import routes from '@configs/api'
import { User } from '@type/user'
import normalizeUser from '@utils/normalizeUser'

const Auth = (
  token: string,
  referralCode?: string | null,
  marketingUserId?: string,
  personalizedLink?: string
): Promise<User> => {
  return new Promise((resolve, reject) => {
    const URL = routes.AUTH
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    const data: {
      referralCode?: string
      marketingUserId?: string
      personalizedLink?: string
    } = {}
    if (referralCode) {
      data.referralCode = referralCode
    }
    if (marketingUserId) {
      data.marketingUserId = marketingUserId
    }
    if (personalizedLink) {
      data.personalizedLink = personalizedLink
    }
    axios
      .post(URL, data, config)
      .then((res) => {
        const user: User = normalizeUser(res.data)
        resolve(user)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
export default Auth
